// src/api/revueFnct.api.ts — SCE Issues
// « Marquer la revue faite » (lot 3 du § 14, 22/10) : la date et le nom de chaque
// revue des FNC-T, dans le bloc `revueFnct` de la ligne `__global__` de
// SCE_UserPrefs (commun à tous : la revue est la même pour tout le monde). Relu
// juste avant l'écriture (modifierBlocGlobal) : deux marquages ne s'écrasent pas.

import { lireBlocGlobal, modifierBlocGlobal } from './reglagesGlobaux.api'
import { CLE_BLOC_REVUE_FNCT, lireBlocRevue, marquerRevue, type RevueFaite } from '@/utils/revueFnct'

export async function lireRevuesFnct(): Promise<RevueFaite[]> {
  return lireBlocRevue(await lireBlocGlobal(CLE_BLOC_REVUE_FNCT))
}

/** Note la revue d'aujourd'hui ; renvoie la liste écrite. */
export async function marquerRevueFaite(par: string): Promise<RevueFaite[]> {
  let ecrit: RevueFaite[] = []
  await modifierBlocGlobal(CLE_BLOC_REVUE_FNCT, (actuel) => {
    const bloc = marquerRevue(actuel, par, new Date())
    ecrit = bloc.revues
    return bloc
  })
  return ecrit
}
